module.exports = __webpack_public_path__ + "static/media/31.e4472070.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/31.jpg
// module id = 206
// module chunks = 0